import React from 'react'
import './PrivacyScreen.scss';

function PrivacyScreen() {
  return (
    <div className='PrivacyScreen'>
        <div className="PrivacyScreen-Wrapper">
            Privacy
        </div>
    </div>
  )
}

export default PrivacyScreen